import { env } from '@config/env';
import { readRuntimeDevConfig } from './localDevBootstrap';
import { useModuleStore } from '../stores/moduleStore';

/**
 * Resolve the tenant API key for unauthenticated public routes (access invite,
 * public survey, etc.). Prefer domain-config fullKey (referrer-validated); fall
 * back to localhost dev overrides when configured.
 */
export function resolvePublicApiKey(): string | null {
  const fromDomain = useModuleStore.getState().config?.apiKey?.fullKey?.trim();
  if (fromDomain) return fromDomain;

  const runtimeKey = readRuntimeDevConfig()?.developmentApiKey?.trim();
  if (runtimeKey) return runtimeKey;

  const envKey = env.developmentApiKey?.trim();
  if (envKey) return envKey;

  return null;
}
